import * as React from 'react';
import * as ReactDom from 'react-dom';
import { Version } from '@microsoft/sp-core-library';
import {
  IPropertyPaneField,
  BaseClientSideWebPart,
  IPropertyPaneConfiguration,
  PropertyPaneTextField,
  PropertyPaneSlider,
  PropertyPaneDropdown,
  IPropertyPaneDropdownOption,
  PropertyPaneButton,
  PropertyPaneButtonType,
  PropertyPaneCheckbox,
  PropertyPaneToggle,
  PropertyPaneFieldType
} from '@microsoft/sp-webpart-base';
import * as pnp from 'sp-pnp-js';
import BannerWp from './components/BannerWp/BannerWp';
import { IBannerWpProps } from './components/BannerWp/IBannerWpProps';
import { IBannerWpWebPartProps } from './IBannerWpWebPartProps';
import * as strings from 'bannerWpStrings';


export default class BannerWpWebPart extends BaseClientSideWebPart<IBannerWpWebPartProps> {

  private supportedLanguageIds: number[];
  private bannerWpFields: IPropertyPaneField<any>[] = [];

  private options;

  constructor() {
    super();
    pnp.setup({
      headers: {
        'Accept': 'application/json;odata=nometadata'
      }
    });
    this.options = this._getLists();
  }

  public render(): void {
    const element: React.ReactElement<IBannerWpProps> = React.createElement(
      BannerWp,
      {
        scrollSpeed: (1 / this.properties.scrollSpeed),
        title: this.properties.title,
        imgListId: this.properties.imgListId,
        showBulletButtons: this.properties.showBulletButtons,
        showThumpnails: this.properties.showThumpnails
      }
    );
    ReactDom.render(element, this.domElement);
  }

  protected get dataVersion(): Version {
    return Version.parse('1.0');
  }

  protected getPropertyPaneConfiguration(): IPropertyPaneConfiguration {
    let templateToggle: any;
    if (this.properties.newLToggle) {
      templateToggle = [
        PropertyPaneTextField('newListName', {
          label: strings.PPaneListName
        }),
        PropertyPaneTextField('newListDescription', {
          label: strings.PPaneListDesc
        }),
        PropertyPaneCheckbox('isContentTypeEnabled', {
          text: strings.PPaneListCheckboxTitle
        }),
        PropertyPaneButton('', {
          buttonType: PropertyPaneButtonType.Normal,
          text: strings.PPaneListButtonTittle,
          onClick: this._createNewList.bind(this)
        }
        )];
    } else {
      templateToggle = [
        PropertyPaneDropdown('imgListId', {
          label: strings.PPaneDropdownTitle,
          options: this.options,
          selectedKey: strings.PPaneDropdownSelectedKey
        }),
        {
          type: PropertyPaneFieldType.Custom,
          targetProperty: '',
          properties: {
            onRender: this._customFieldRender.bind(this),
            value: undefined,
            context: undefined
          }
        }
      ];
    }
    return {
      pages: [
        {
          header: {
            description: strings.header
          },
          groups: [
            {
              groupName: strings.BasicGroupName,
              groupFields: [
                PropertyPaneSlider('scrollSpeed', {
                  label: strings.PPaneSliderTittle,
                  min: 1,
                  max: 5,
                  step: 0.5,
                  value: 2
                }),
                PropertyPaneToggle('showBulletButtons', {
                  label: strings.PPaneToggleBullets,
                  onText: strings.PPaneToggleOn,
                  offText: strings.PPaneToggleOff
                }),
                PropertyPaneToggle('showThumpnails', {
                  label: strings.PPaneToggleThumpnails,
                  onText: strings.PPaneToggleOn,
                  offText: strings.PPaneToggleOff
                }),
                PropertyPaneToggle('newLToggle', {
                  label: strings.PPaneToggleList,
                  onText: strings.PPaneToggleListOn,
                  offText: strings.PPaneToggleListOff
                })
              ]
            },
            {
              groupName: strings.ImgListGroupName,
              groupFields: templateToggle
            }
          ]
        }
      ]
    };
  }

  /**
   * Uses Sharepoint API to retrieve a list of picture lists and add it to the options of the dropdown on the property pane.
   */
  private _getLists(): IPropertyPaneDropdownOption[] {
    const optionsList: IPropertyPaneDropdownOption[] = [];
    pnp.sp.web.lists.filter('BaseTemplate eq 109').get().then((items: any[]) => {
      for (var i = 0; i < items.length; i++) {
        optionsList.push({
          index: i,
          key: items[i].Id,
          text: items[i].Title
        });
      }
      if (items.length === 0) {
        this.properties.hasImages = false;
      }
      this.properties.hasImages = true;
    }, (error: any) => {
      console.log('Error');
    });
    return optionsList;
  }

  /**
   * Uses the Sharepoint API to create a new list with the active custom field.
   */
  private _createNewList(elem: HTMLElement) {
    var fieldXML = "<Field DisplayName='Ativo' Type='Boolean' Required='TRUE' Name='ativo' Group='Custom Columns' />";

    pnp.sp.web.lists.add(
      this.properties.newListName,
      this.properties.newListDescription,
      109,
      this.properties.isContentTypeEnabled
    ).then(() => {
      pnp.sp.web.lists.getByTitle(this.properties.newListName).fields.createFieldAsXml(fieldXML)
        .then(() => {
          pnp.sp.web.lists.getByTitle(this.properties.newListName).fields.addUrl('Link').then(() => {
            this.properties.newListDescription = undefined;
            this.properties.newListName = undefined;
            this.properties.isContentTypeEnabled = false;
            this.properties.newLToggle = false;
            this.options = this._getLists();
            this.context.propertyPane.refresh();
          });
        });
    });
  }


  /**
   * Renders the custom upload button on the Property Pane.
   * @param elem Html HTMLElement onto which to load the button.
   */
  private _customFieldRender(elem: HTMLElement): void {
    if (this.properties.imgListId != null)
      pnp.sp.web.lists.getById(this.properties.imgListId).select('url').expand('RootFolder, ParentWeb')
        .select('Title,RootFolder/ServerRelativeUrl, ParentWeb/Url').get().then((response: any) => {
          var uri;
          if (response != null) {
            debugger;
            uri = encodeURI(response.ParentWeb.Url + '/' + response.Title);
            elem.innerHTML = "<span class='ms-Button-description'><a class='ms-Link ms-button' href = " + uri + ">" + strings.PPaneBTNImageUpload + "</a></span>";
          } else {
            elem.innerHTML = '';
          }
        });
  }


}

